import { isDevEnv } from 'utilities/consts/webpack-consts.js';
import { FetchError } from 'utilities/fetch/api-gateway.js';
import { getWindowLocation } from 'utilities/window.js';
import { ILoadPageError, ILoadPageResult } from './layout-build-types.js';
import { LayoutErrorHelmetHook, getIs4xx } from './layout-error-helmet-hook.js';

export const ErrorMessage = ({ error }: { error: ILoadPageError }) => {
  if (isDevEnv(false)) {
    if (error.type === FetchError.NETWORK_ERROR) {
      return (
        <>
          <pre className="DebugArea">Network Error</pre>
          {error.message && <pre className="DebugArea">{error.message}</pre>}
          {error.stack && <pre className="DebugArea">{error.stack}</pre>}
        </>
      );
    }
    if (error.type === FetchError.SERVER_RESPONSE_ERROR) {
      return (
        <>
          <pre className="DebugArea">{`Server Error`}</pre>
          {error.message && <pre className="DebugArea">{error.message}</pre>}
          {error.stack && <pre className="DebugArea">{error.stack}</pre>}
        </>
      );
    }
    if (error.type === FetchError.COMPONENT_NOT_FOUND) {
      return (
        <>
          <pre className="DebugArea">Layout Load Error</pre>
          {error.message && <pre className="DebugArea">{error.message}</pre>}
        </>
      );
    }
    return (
      <>
        {error.name && <pre className="DebugArea">{error.name}</pre>}
        {error.message && <pre className="DebugArea">{error.message}</pre>}
        {error.stack && <pre className="DebugArea">{error.stack}</pre>}
      </>
    );
  } else {
    if (getIs4xx(error.code)) {
      return <p>404: Page Not Found</p>;
    }
    return (
      <p>
        <a onClick={getWindowLocation().reload}>Please refresh the page.</a>
      </p>
    );
  }
};

export const LayoutError = ({ res }: { res: ILoadPageResult }) => {
  LayoutErrorHelmetHook({ res });
  if (!res.layoutLoadSuccess) {
    return (
      <div className="errorMessage">
        <div className="errorMessage-content">
          <h1>Oops!</h1>
          <h2>{"There's been an error"}</h2>
          <ErrorMessage error={res.error} />
        </div>
      </div>
    );
  }
  return null;
};
